import { Injectable } from '@angular/core';

import type { TOfferKind } from '@recruitee/offers-types';

import { AnalyticsBase } from '../lib/analytics-base';

@Injectable()
export class TeamMembersAnalytics extends AnalyticsBase {
  public readonly namespace = 'Team';
  public readonly requireViewContext = true;

  public trackInviteMembers() {
    this.track('InviteNewMembers', {});
  }

  public trackMemberAccess(accessType?: TOfferKind | 'requisition') {
    this.track('ChangeMemberAccess', accessType ? { accessType } : {});
  }
}
